/*
 * @ Author: wangjiyu
 * @Date: 2019-12-19 09:52:52
 * @LastEditTime: 2020-04-16 10:27:25
 * @LastEditors: wangjiyu
 * @Description: file content
 */
class Arr {
    // 遍历类数组
    public arrForEach = (fakeArr, fn) => {
        let i = void 0;
        let item = void 0;
        let result = void 0;
        const length = fakeArr.length || 0;
        for (i = 0; i < length; i++) {
            item = fakeArr[i];
            result = fn.call(fakeArr, item, i);
            if (result === false) {
                break;
            }
        }
    };
}

export default new Arr();
